/** Display name and role label for UI */

export function getDisplayName(user) {
  if (!user) return '';
  const first = (user.firstName || '').trim();
  const last = (user.lastName || '').trim();
  const combined = `${first} ${last}`.trim();
  if (combined) return combined;
  return (user.fullName || user.name || '').trim() || 'Foydalanuvchi';
}

/** Show role badge only for staff (not regular users) */
export function getRoleLabel(user) {
  if (!user?.role) return null;
  const role = String(user.role).toLowerCase();
  if (role === 'user') return null;
  return role;
}

export function shouldShowRole(user) {
  return getRoleLabel(user) != null;
}
